import { Company } from "../../../modules/portal/companies/company.type";
import { Partner } from "../../../modules/portal/partners/partner.type";

export class ViewAs {
  partner: Partner;
  company: Company;

  constructor(viewAs: Pick<ViewAs, "partner" | "company">) {
    this.partner = viewAs.partner;
    this.company = viewAs.company;
  }

  public get partnerId(): string {
    return this.partner?.id || null;
  }

  public get companyId(): string {
    return this.company?.id || null;
  }
}
